import { Subject } from 'rxjs';
import { ReplaySubject } from 'rxjs';
import { StorageKeys } from '../../shared/models/storage-keys';

import { Injectable } from '@angular/core';
import { LocalStorageService } from './local-storage.service';

@Injectable()
export class AuthorizedUser {
	userChanged: Subject<boolean> = new ReplaySubject();
	loginCredentials: any;

	constructor(
		private localStorage: LocalStorageService
	) {

	}

	setLoginCredentials(credentials){
		this.loginCredentials = credentials;
	}

	get clientId(): number {
		return this.localStorage.get(StorageKeys.clientId);
	}

	get username(): string {
		return this.localStorage.get(StorageKeys.username);
	}

	get name(): string {
		return this.localStorage.get(StorageKeys.fullname);
	}

	get firstName(): string {
		return this.localStorage.get(StorageKeys.firstName);
	}

	get lastName(): string {
		return this.localStorage.get(StorageKeys.lastName);
	}

	get userType(): string {
		return this.localStorage.get(StorageKeys.userType);
	}


	get authorities(): string[] {
		return JSON.parse(this.localStorage.get(StorageKeys.authorities));
	}

	get branch(): string {
		return this.localStorage.get(StorageKeys.branch);
	}

	get jti(): string {
		return this.localStorage.get(StorageKeys.jti);
	}
	get authenticationDomain(): string {
		return this.localStorage.get(StorageKeys.authenticationDomain);
	}

	get roles(): string[] {
		return JSON.parse(this.localStorage.get(StorageKeys.roles));
	}


}

